/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

import Input from '../../components/form-control/Input';
import Logo from '../../components/Logo';
import Button from '../../components/form-control/Button';
import Page from '../../components/PageWrapper';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { IResetPasswordDTO } from '../settings/Password';
import { resetPassword } from '../../api/requests';
import { toast } from 'react-toastify';
import { SIGN_IN } from '../../resources/links';
import useUserAccount from '../../hooks/stateHooks/userAccountHook';
import useAuth from '../../hooks/authHook';

function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [submitting, setSubmitting] = useState<boolean>(false);
  const { signOut } = useUserAccount();

  const userEmail = searchParams.get('email');
  const token = searchParams.get('token');
  const ref = searchParams.get('ref');

  useEffect(() => {
    signOut(false);
  }, [])

  const submitHandler = (values: any) => {
    console.log("token", token);
    console.log("ref", ref);
    if (token && ref) {
      const payload: IResetPasswordDTO = {
        password: values.password,
        password_confirmation: values.confirmPassword,
        reference: ref!,
        token: token
      };

      setSubmitting(true);
      resetPassword(payload)
        .then((response: any) => {
          toast.success('Password reset successfully. Log in to continue. ', {
            autoClose: 5000
          });
          navigate(`/auth/${SIGN_IN}`, { replace: true });
        })
        .catch((error: any) => {
          toast.error(error.detail, {autoClose: 5000});
        })
        .finally(() => setSubmitting(false));
    }
  };

  return (
    <div className="bg-white mx-1 rounded-md py-16 md:mx-14 font-poppins w-full md:w-1/2 lg:w-1/3">
      <h3 className="text-4xl text-center">Reset Password</h3>
      <p className="text-sm sm:text-base py-2 text-center  text-[#9CA3AF]">
        Assign new password to account
      </p>

      <Formik
        initialValues={{
          password: '',
          confirmPassword: ''
        }}
        validateOnChange={false}
        validateOnBlur={true}
        validationSchema={Yup.object({
          password: Yup.string()
            .trim()
            .required('Password is required')
            .min(8, 'A minimum of 8 characters required')
            .test({
              message: 'User email cannot be used as password',
              test: (value) => value !== userEmail
            })
            .matches(
              /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/,
              'Password must include at least two of the following: an uppercase character, a number, a special character'
            ),
          confirmPassword: Yup.string()
            .required('Password confirmation is required')
            // @ts-ignore
            .oneOf([Yup.ref('password'), null], 'Passwords must match')
        })}
        onSubmit={(values) => {
          submitHandler(values);
        }}>
        {({ values, errors, isSubmitting, handleSubmit, handleChange, handleBlur }) => (
          <form className="px-2 md:px-24 my-7" onSubmit={handleSubmit}>
            <h3 className="text-center text-lg font-bold">{userEmail}</h3>

            <div className="my-5">
              <Input
                name="password"
                label="Password"
                value={values.password}
                type="password"
                wrapperClasses="my-5"
                showPasswordIcon
                required
                error={errors.password}
                onBlur={handleBlur}
                onChange={handleChange}
                helperText={errors.password}
                description={`Must be at least 8 characters. Include an uppercase character, a number and a special character`}
              />
              {errors.password && (
                <div className="flex flex-col font-bold text-gray-500 text-sm">
                  <div className="">
                    <span> Password must:</span>
                    <div className="flex items-center gap-2">
                      <div className="h-2 w-2 bg-gray-500 rounded-full  "></div>{' '}
                      <span>Be between 9 and 64 characters</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="h-2 w-2 bg-gray-500 rounded-full  "></div>{' '}
                      <span>Includes at least two of the following:</span>
                    </div>
                  </div>

                  <div className="ml-5 flex flex-col">
                    <span>&#x2022; An uppercase character</span>
                    <span>&#x2022; A number</span>
                    <span>&#x2022; A special character</span>
                  </div>
                </div>
              )}

              <Input
                name="confirmPassword"
                label="Confirm Password"
                value={values.confirmPassword}
                type="password"
                wrapperClasses="my-5"
                showPasswordIcon
                required
                error={errors.confirmPassword}
                onBlur={handleBlur}
                onChange={handleChange}
                helperText={errors.confirmPassword}
              />

              <Button
                type="submit"
                label="Submit"
                className="mt-5 flex justify-center rounded px-6 w-full bg-black text-white hover:text-white"
                loading={submitting}
                disabled={submitting}
              />
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default ResetPassword;

{
  /* <div className="flex justify-center my-8">
          <Logo rounded />
        </div> */
}
